export default "__VITE_ASSET__Bpbp0tEY__"